var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M12 8l-6 6 1.4 1.4 4.6-4.6 4.6 4.6L18 14l-6-6z"}})}
var staticRenderFns = []

export { render, staticRenderFns }